export default __webpack_public_path__ + "static/media/info_icon.65554e37.svg";